import React from 'react';
import { bookingShape, userShape } from 'constants/propTypes';
import { withBooking } from 'components/queries/GetBookingQuery';
import { getAssistances, getValidExtras } from 'utils/booking';
import { StyledStickyContainer } from '../BookingDetails.styles';
import BookingDetailsTable from '../BookingDetailsTable';
import ModuleTabs from '../ModuleTabs';
import Assistance from './Assistance';
import { bookingStatus } from '../../../types/booking';

const Index = ({ booking, user = {} }) => {
  const { canAddSpecialAssistanceToBooking = false, isReadOnly = false } = user;
  const journeyExtras = [...booking.outboundExtras, ...booking.inboundExtras];
  const status = booking.displayStatus;
  const canAddAssistance =
    !isReadOnly &&
    canAddSpecialAssistanceToBooking &&
    [bookingStatus.CONFIRMED, bookingStatus.ON_HOLD, bookingStatus.TEMPORARILY_ON_HOLD].includes(status);
  const assistances = getAssistances(journeyExtras);

  const filteredExtras = [
    ...getValidExtras(booking.outboundExtras),
    ...getValidExtras(booking.insurances),
    ...getValidExtras(booking.hotels),
    ...getValidExtras(booking.inboundExtras),
    ...getValidExtras(booking.travelPassProducts)
  ];

  return (
    <>
      <StyledStickyContainer id="booking-details">
        <BookingDetailsTable booking={booking} />
        <ModuleTabs
          notes={booking.notes}
          reference={booking.reference}
          outbound={booking.nonExchangedOutbound}
          inbound={booking.nonExchangedInbound}
          assistances={assistances}
          extras={filteredExtras}
          booking={booking}
        />
      </StyledStickyContainer>
      <Assistance booking={booking} canAddSpecialAssistanceToBooking={canAddAssistance} />
    </>
  );
};

Index.propTypes = {
  booking: bookingShape,
  user: userShape
};

const options = {
  centerLoader: true
};
export default withBooking(Index, undefined, options);
